import { useTranslation } from "react-i18next";
import { formatPercent } from "@/utils/formatters";
import { WrappedCardFrame } from "./WrappedCardFrame";
import type { TopCategoriesData, WrappedCard } from "../types";

interface TopCategoriesCardProps {
  card: WrappedCard;
}

export const TopCategoriesCard = ({ card }: TopCategoriesCardProps) => {
  const { t } = useTranslation("wrapped");
  const data = card.data as unknown as TopCategoriesData;

  return (
    <WrappedCardFrame title={card.title} body={card.body}>
      {data.primary?.income_pct != null ? (
        <p className="mb-4 rounded-[var(--ds-radius-md)] bg-[var(--app-primary-chip-bg)] px-4 py-3 text-sm font-semibold text-[var(--app-text)]">
          {t("wrapped.primaryVsIncome", {
            category: data.primary.name,
            percent: formatPercent(data.primary.income_pct),
          })}
        </p>
      ) : null}
      <figure aria-label={t("wrapped.categories")} className="min-w-0">
        <figcaption className="mb-4 text-sm font-semibold text-[var(--app-text)]">{t("wrapped.categories")}</figcaption>
        {data.items.length ? (
          <div className="space-y-3">
            {data.items.map((item) => (
              <div key={item.name} className="grid min-w-0 grid-cols-[minmax(5rem,6rem)_minmax(0,1fr)_3.5rem] items-center gap-3 text-xs">
                <span className="truncate text-[var(--app-chart-axis)]" title={item.name}>{item.name}</span>
                <div className="h-6 overflow-hidden rounded-r-lg bg-[var(--app-panel-raised-track-bg)]">
                  <div
                    className="h-full rounded-r-lg bg-[var(--app-chart-series-1)]"
                    style={{ width: `${Math.min(Math.max(item.pct, 0), 100)}%` }}
                  />
                </div>
                <span className="tabular-nums text-[var(--app-text-secondary)]">{formatPercent(item.pct)}%</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-[var(--app-text-secondary)]">{t("wrapped.categoriesEmpty")}</p>
        )}
      </figure>
    </WrappedCardFrame>
  );
};
